import { render, staticRenderFns } from "./EditWorkspace.vue?vue&type=template&id=4078703e&"
import script from "./EditWorkspace.vue?vue&type=script&lang=js&"
export * from "./EditWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports